import React, {useContext} from 'react';
import {Controller} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldConfigSize} from '@src/@types/components/Form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import CustomSelect from '@src/components/Fields/CustomSelect';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import useFormValue from '@src/hooks/useFormValue';

const emptyArray: never[] = [];

export function PaymentTypeField({rowIndex: index}: IListColumnProps) {
    const {
        control,
        fieldName,
        modelOptions = {},
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const {currentValue} = useFormValue(fieldName ?? '');
    const [design] = useContext(FormFieldDesignContext);

    return <>
        <Controller
                control={control}
                name={`${fieldName}.${index}.payment_type_id`}
                render={({field: {name, value, onChange, onBlur}, fieldState: {error}}) => {
                    return <CustomSelect
                            label="OrderForm.payments.fields.payment_type"
                            className={classnames({
                                'is-invalid': Boolean(error)
                            })}
                            name={name}
                            size={FormFieldConfigSize.SM}
                            options={modelOptions.paymentTypes ?? emptyArray}
                            readOnly={design.fieldsAreReadOnly || forceReadonly || Boolean(currentValue?.[index].id)}
                            disabled={design.fieldsAreDisabled || forceDisabled || Boolean(currentValue?.[index].id)}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            menuPortalTarget={document.body}
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.payment_type_id`}/>
    </>;
}
